import React from "react";
import { generateAvatar } from "@/skate/lib/rank";

export const SkaterAvatar = ({ user, size = 40, className = "" }) => {
  const src = user?.picture || generateAvatar(user?.username || user?.user_id || user?.email);
  return (
    <div
      className={`relative shrink-0 overflow-hidden border border-zinc-800 ${className}`}
      style={{ width: size, height: size }}
      data-testid="skater-avatar"
    >
      <img
        src={src}
        alt={user?.username || user?.name || "skater"}
        className="w-full h-full object-cover"
        onError={(e) => { e.currentTarget.src = generateAvatar(user?.user_id || "anon"); }}
      />
    </div>
  );
};

export default SkaterAvatar;
